export const ContentComponent = {
  components: {
    Content: {
      baseStyle: {
        py: 0,
        px: { base: 3, xs: 4, md: 6, lg: 8, xl: 10 },
        width: '100%',
        position: 'relative',
        '--inner-content': { 
          base: 'calc(100vw - 36px)',
          xs: 'calc(100vw - 44px)',
          md: 'calc(var(--container-width) - 60px)',
          lg: 'calc(var(--container-width) - 76px)',
          xl: 'calc(var(--container-width) - 92px)'
        }
      }
    }
  }
}
